(ns ductile.ui.dependent-selects
  (:require [clojure.string :as str]
            [ductile.ui.components :as ui]
            [ductile.ui.locale :as locale :refer [tr]]))

(defn select-control [{:as props :keys [label options value on-change placeholder]}]
  [:div {:class ["rounded" "bg-gray-200" "p-[3px]" "pt-0" "border" "border-gray-300"]}
   [:label {:class ["font-bold" "text-xs" "pl-1"]} label]
   [ui/select (assoc props
                     :class ["text-sm" "pr-4"]
                     :choices (map (fn [opt] {:ui/value opt
                                              :ui/label (str opt)}) options)
                     :placeholder-selectable? true)]])

(defn dependent-selects
  "Props:
   - :levels    => vector of level descriptors, each {:group-key kw-or-nil :label string :options [..]}
   - :value     => flat map {group-key -> chosen}
   - :on-change => (fn [new-value]) called with updated flat map after a selection"
  [{:keys [levels value on-change class]}]
  (let [levels (or levels [])
        value  (or value {})]
    [:div {:class ["flex" "flex-wrap" "gap-2" "mx-2" "mt-2"]}
     (doall
      (map-indexed
       (fn [idx {:keys [group-key label options]}]
         (let [current (when group-key (get value group-key))
               placeholder (tr "%1…" label)]
           ^{:key (str (or (some-> group-key name) "leaf") ":" idx)}
           [select-control
            {:label (or label (tr "Select"))
             :options (or options [])
             :value current
             :placeholder placeholder
             :on-change (fn [v]
                          ;; Build the new flat map by keeping selections from
                          ;; earlier levels, setting current, and dropping later.
                          (let [prior-keys  (->> (subvec (vec levels) 0 idx)
                                                 (map :group-key)
                                                 (filter some?))
                                kept        (into {} (map (fn [k] [k (get value k)]) prior-keys))
                                new-map     (if group-key
                                              (assoc kept group-key v)
                                              kept)
                                cleaned     (into {} (remove (comp nil? val) new-map))]
                            (on-change cleaned)))}]))
       levels))]))

(comment
  (def demo-layout
    {:shelf/row {"A" {:shelf/place {1 {:shelf/level {1 {:shelf/box ["rot" "blau"]}
                                                     2 {:shelf/box ["rot" "blau"]}}}
                                    2 {:shelf/level [1 2]}}}
                 "B" {:shelf/place {1 {:shelf/level [1 2]}}
                      :storage/loading-zone? true}}})

  (defn ignore-storage-ns? [k]
    (and (keyword? k) (= (namespace k) "storage")))

  (defn demo-view []
    (let [current-selection @(deframe/!route-get ::shelf-selection {})
          levels (levels-from-root demo-layout current-selection ignore-storage-ns?)]
      [:div.p-6
       [ui/with-label "Arbitrarily nseted input data:"
        [:pre.text-xs.bg-gray-50.border.rounded.p-3.overflow-x-auto
         (with-out-str (pprint/pprint demo-layout))]]
       [:div.mt-6
        [dependent-selects {:levels levels
                            :value current-selection
                            :on-change #(deframe/route-assoc! ::shelf-selection %)}]]
       [:div.mt-6
        [ui/with-label "External state deframe state:"
         [:pre.text-xs.bg-gray-50.border.rounded.p-3.overflow-x-auto
          (pr-str current-selection)]]]])))
